import FocusableBackButton from '@components/FocusableBackButton';
import FocusableIconButton from '@components/FocusableIconButton';
import Loading from '@components/Loading';
import { useRetryPaymentContext } from '@context/Payment/RetryPayment';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect } from 'react';

import PaymentButton from '../../../components/PaymentButton';
import {
  generateRetryPaymentMethodFocusKey,
  RETRY_PAYMENT_METHOD_NEW
} from '../focusKey';

import * as styles from './styles';

const RetryPaymentView = () => {
  const {
    paymentMethods,
    setButtonFocus,
    loaderVisible,
    openRetryPaymentModal,
    goPaymentRegistration
  } = useRetryPaymentContext();

  const { focusKey } = useFocusable();

  useEffect(() => {
    setButtonFocus();
  }, [setButtonFocus]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div css={styles.container}>
        <div css={styles.mainContainer}>
          <FocusableBackButton />
          <div css={styles.title}>결제수단을 선택해주세요</div>
        </div>
        <div css={styles.rightContainer}>
          <div css={styles.subtitle}>등록된 결제 수단</div>
          <div css={styles.rightButtonContainer}>
            {paymentMethods.map((paymentMethod, index) => (
              <PaymentButton
                key={index}
                paymentMethod={paymentMethod}
                focusKey={generateRetryPaymentMethodFocusKey(index)}
                onEnterPress={() => openRetryPaymentModal(paymentMethod)}
              />
            ))}
            <FocusableIconButton
              focusKey={RETRY_PAYMENT_METHOD_NEW}
              onEnterPress={goPaymentRegistration}
              iconType="plus"
            >
              새로운 결제수단 등록하기
            </FocusableIconButton>
          </div>
        </div>
      </div>
      <Loading visible={loaderVisible} />
    </FocusContext.Provider>
  );
};

export default RetryPaymentView;
